import { render, staticRenderFns } from "./MarginCard.vue?vue&type=template&id=58961b2e&scoped=true&"
import script from "./MarginCard.vue?vue&type=script&lang=js&"
export * from "./MarginCard.vue?vue&type=script&lang=js&"
import style0 from "./MarginCard.vue?vue&type=style&index=0&id=58961b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58961b2e",
  null
  
)

export default component.exports